import React, { useState } from "react";
import supabase from "../../supabase";
import { v4 as uuidv4 } from "uuid";

const AddUser = ({ profile, organization, onCancel }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Writer");
  const [loading, setLoading] = useState(false);

  const sendInviteEmail = async (email, token, role) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3000";

    const BASE_API_URL =
      process.env.REACT_APP_BASE_URL || "http://localhost:5000";

    const inviteLink = `${BASE_URL}/set-password?token=${token}&email=${email}&role=${role}`;

    try {
      const response = await fetch(`${BASE_API_URL}/send-invite`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          inviteLink,
          organization: organization?.name,
          inviterName: profile?.name,
        }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error);
      }

      //alert("Invite sent successfully!");
    } catch (error) {
      console.error("Email failed to send:", error.message);
      alert("Failed to send invite email.");
    }
  };

  const handleInvite = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = uuidv4(); // Creates a secure token

      // Step 1: Add the invitee to the "Invites" table
      const emailNormalized = (email || "").trim().toLowerCase();
      const { error: inviteError } = await supabase.from("Invites").insert([
        {
          company: profile.company_id,
          role,
          name,
          email: emailNormalized,
          token,
        },
      ]);

      if (inviteError) throw inviteError;

      await sendInviteEmail(email, token, role);

      alert("Invite sent successfully!");
      setName("");
      setEmail("");
      setRole("Writer");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.card}>
      <h2 style={styles.heading}>Invite a New Member</h2>
      <form onSubmit={handleInvite}>
        <div style={styles.row}>
          <div style={styles.field}>
            <label style={styles.label}>Name</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Jane Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              placeholder="jane@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Role</label>
            <select
              style={styles.select}
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="Writer">Writer</option>
              <option value="Admin">Admin</option>
              <option value="Editor">Editor</option>
              <option value="Approver">Approver</option>
            </select>
          </div>
        </div>

        <div style={styles.actions}>
          {onCancel && (
            <button type="button" onClick={onCancel} style={styles.cancelButton}>
              Cancel
            </button>
          )}
          <button
            type="submit"
            style={{
              ...styles.submitButton,
              ...(loading ? styles.submitButtonDisabled : {}),
            }}
            disabled={loading}
          >
            {loading ? "Inviting..." : "Send Invite"}
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  card: {
    background: "#fff",
    borderRadius: 14,
    border: "1px solid #e5e7eb",
    padding: "20px 24px",
  },

  heading: {
    fontSize: 16,
    fontWeight: 700,
    color: "#111827",
    margin: "0 0 16px",
  },

  row: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
  },

  field: {
    flex: "1 1 200px",
    display: "flex",
    flexDirection: "column",
  },

  label: {
    fontSize: 13,
    fontWeight: 700,
    color: "#4b5563",
    marginBottom: 6,
  },

  input: {
    border: "1px solid #d1d5db",
    borderRadius: 8,
    padding: "10px 12px",
    fontSize: 14,
    color: "#111827",
    outline: "none",
    boxSizing: "border-box",
  },

  select: {
    border: "1px solid #d1d5db",
    borderRadius: 8,
    padding: "10px 12px",
    fontSize: 14,
    color: "#111827",
    background: "#fff",
    cursor: "pointer",
    boxSizing: "border-box",
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 18,
  },

  cancelButton: {
    background: "#e2e8f0",
    color: "#111827",
    border: "none",
    borderRadius: 10,
    padding: "10px 16px",
    fontWeight: 700,
    cursor: "pointer",
  },

  submitButton: {
    background: "#00876e",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "10px 16px",
    fontWeight: 700,
    cursor: "pointer",
  },

  submitButtonDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
};

export default AddUser;
